module.exports = __webpack_public_path__ + "static/media/feedback-2.ba131044.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/main/features/assets/feedback-2.jpg
// module id = 1048
// module chunks = 0